export const useFunnelRoute = () => {
  const route = useRoute();

  const isFunnelPage = computed(() => currentFunnelPage(route.name) !== undefined);

  // The chrome is reduced wherever a search is live — the same two zones the session timeout runs in.
  const isCollapsed = computed(() => currentSessionArea(route.name) !== undefined);

  const billingStatus = computed(() => funnelPageStatus('billing', route.name));
  const isAtOrPastBillingPage = computed(() => billingStatus.value !== 'upcoming');
  const isPastBillingPage = computed(() => billingStatus.value === 'done');

  return {
    isCollapsed,
    isFunnelPage,
    isAtOrPastBillingPage,
    isPastBillingPage,
  };
};
